
import createIcon from "./createIcon";

export const XCircleIcon = createIcon('XCircle', (props) => {
  return (
    <svg {...props} viewBox="0 0 57 57">
      <g>
        <path id="path" d="M28.34 57C12.6 57 -0.16 44.23 -0.16 28.5C-0.16 12.76 12.6 0 28.34 0C44.08 0 56.84 12.76 56.84 28.5C56.84 44.23 44.08 57 28.34 57Z" fill={props.color} fillOpacity="1" fillRule="nonzero" />
        <g>
          <path id="path" d="M40.38 37.4C41.2 38.22 41.2 39.56 40.38 40.38C39.97 40.79 39.43 40.99 38.89 40.99C38.35 40.99 37.81 40.79 37.4 40.38L29 31.97L20.59 40.38C20.18 40.79 19.64 40.99 19.1 40.99C18.56 40.99 18.02 40.79 17.61 40.38C16.79 39.56 16.79 38.22 17.61 37.4L26.02 28.99L17.61 20.59C16.79 19.77 16.79 18.43 17.61 17.61C18.43 16.79 19.77 16.79 20.59 17.61L29 26.02L37.4 17.61C38.22 16.79 39.56 16.79 40.38 17.61C41.2 18.43 41.2 19.77 40.38 20.59L31.97 28.99L40.38 37.4Z" fill={props.fill === 'none' ? '#FFFFFF' : props.fill} fillOpacity="1" fillRule="nonzero" />
        </g>
      </g>
    </svg >
  );
});
